/* 🤖 this file was generated by svg-to-ts */
export const matIconFilterList: {
  name: 'filter-list';
  data: string;
} = {
  name: 'filter-list',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z"/></svg>`
};
